import type { Endpoints } from './types'

export const defaultEndpoints: Endpoints = {
	getAuthServiceUrl: () => 'api/v2/auth/service/url',
	getUser: ({ baseURL, accountId }) =>
		`${baseURL}/${accountId ? `auth/${accountId}` : 'auth?refresh=true'}`,
	forgotPassword: ({ baseURL }) => `${baseURL}/auth/forgot`,
	resetPassword: ({ baseURL }) => `${baseURL}/auth/reset`,
	login: ({ baseURL }) => `${baseURL}/auth`,
	logout: ({ baseURL }) => `${baseURL}/auth`,
}

export const defaultParseResponse = (res) => res
